module.exports = __webpack_public_path__ + "static/media/ArchiveIconOriginal.9fce9fb7.svg";